import React, { FC } from 'react'

import Link from 'next/link'
import { FieldErrors, UseFormTrigger, UseFormWatch } from 'react-hook-form'
import { UseFormSetValue } from 'react-hook-form/dist/types/form'

import { Txt, Icon } from 'src/components/atoms'
import { EditAssignTableWithSegmentedControls } from 'src/components/molecules/projects/EditAssignTableWithSegmentedControls'

import { Routes } from 'src/routes'
import { ProfileEntity, UpsertProjectFormEntity, ProjectDetailEntity } from 'src/types'
import { CompassRoleEntity } from 'src/types/entities/CompassRole'

type Props = {
  profile: ProfileEntity
  compassRoles: CompassRoleEntity[]
  project: ProjectDetailEntity
  setValue: UseFormSetValue<UpsertProjectFormEntity>
  watch: UseFormWatch<UpsertProjectFormEntity>
  formErrors: FieldErrors<UpsertProjectFormEntity>
  trigger: UseFormTrigger<UpsertProjectFormEntity>
  defaultSelectedTab?: 'internal' | 'external'
  className?: string
}

export const ProjectAssignInputArea: FC<Props> = ({
  profile,
  compassRoles,
  project,
  watch,
  setValue,
  formErrors,
  trigger,
  defaultSelectedTab,
  className,
}) => {
  return (
    <div className={className}>
      {/* NOTE: EditAssignTableWithSegmentedControls の上部部分をstickyで固定する関係でpositionを上部部分には設定しない */}
      <div className="tw-px-s2 tw-pb-s2 tw-bg-surface-primary">
        <div className="tw-flex tw-justify-end tw-pb-s1 tw-mt-s2">
          <Link href={Routes.HelpPolicy.path} target="_blank">
            <div className="tw-inline-flex tw-items-center tw-text-roovPrimary-default">
              <Txt sizeType="s" className="tw-font-bold tw-underline hover:tw-no-underline">
                ROOV compass権限について
              </Txt>
              <Icon path="help-circle/soft/line" size="--r1" className="tw-ml-s-4" />
            </div>
          </Link>
        </div>

        <EditAssignTableWithSegmentedControls
          watch={watch}
          setValue={setValue}
          formErrors={formErrors}
          trigger={trigger}
          project={project}
          profile={profile}
          compassRoles={compassRoles}
          defaultSelectedTab={defaultSelectedTab}
        />
      </div>
    </div>
  )
}
